import { includePresets } from '@codeleap/common'
import { variantProvider } from '..'

export type CenterWrapperComposition = 'wrapper' | 'innerWrapper'

const createCenterWrapperStyle = variantProvider.createVariantFactory<CenterWrapperComposition>()

const presets = includePresets(styles => createCenterWrapperStyle(() => ({ innerWrapper: styles })))

const MAX_WIDTH = 1280

export const CenterWrapperStyles = {
  ...presets,
  default: createCenterWrapperStyle(theme => ({
    wrapper: {
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      width: '100%'
    },
    innerWrapper: {
      flex: 1,
      display: 'flex',
      width: '100%',
      maxWidth: MAX_WIDTH,

      paddingLeft: theme.spacing.value(5),
      paddingRight: theme.spacing.value(5),

      [theme.media.down('xxmid')]: {
        paddingLeft: theme.spacing.value(2.5),
        paddingRight: theme.spacing.value(2.5)
      }
    }
  }))
}
